<template>
    <div class="personnelAuthority"
      v-loading="showLoad"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <iframe class="register-iframe" :src="personnelAuthorityUrl" frameborder="0" @load="iframeLoad"
        ></iframe>
    </div>
</template>


<script>
import Url from "../../../service/base-url.js";
import { mapState } from "vuex";
export default {
  name: "personnelAuthority",
  data() {
    return {
      showLoad: true
    };
  },
  methods: {
    iframeLoad() {
      this.showLoad = false;
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    personnelAuthorityUrl() {
      return (
        Url.baseUrl +
        "/MenuPermissionConfiguration/simpleRole/index?appid=" +
        "1709261010180000101"
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.personnelAuthority
  height: 100%;
  .register-iframe
    width: 100%;
    height: 100vh;    
</style>
